import Vue from 'vue'
import Router from 'vue-router'


import cmbc_cr_list from '@/views/list'
import cmbc_cr_detail_1 from '@/views/detail_1'
import cmbc_cr_detail_2 from '@/views/detail_2'
import cmbc_cr_time_table from '@/views/time_table'
import cmbc_cr_create_order_1 from '@/views/create_order_1'
import cmbc_cr_create_order_2 from '@/views/create_order_2'
import cmbc_cr_order_comfirm from '@/views/order_comfirm'
import cmbc_cr_order_list from '@/views/order_list'
import cmbc_cr_order_detail from '@/views/order_detail'

import cmbc_cr_main from '@/views/main'
import cmbc_cr_main_detail from '@/views/main_detail'



Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/venue/list',
			name: 'cmbc_cr_main',
			component: cmbc_cr_main,
			meta: {
				keepAlive: true,
				requireAuth: false,
				title: ''
			}
		},{
			path: '/cmbc_cr_main_detail/:service_id/:sport_type',
			name: 'cmbc_cr_main_detail',
			component: cmbc_cr_main_detail,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: ''
			}
		},
		
		{
			path: '/index',
			name: 'cmbc_cr_list',
			component: cmbc_cr_list,
			meta: {
				keepAlive: true,
				requireAuth: false,
				title: ''
			}
		},{
			path: '/cmbc_cr_detail_1/:service_id',
			name: 'cmbc_cr_detail_1',
			component: cmbc_cr_detail_1,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: ''
			}
		},{
			path: '/cmbc_cr_detail_2',
			name: 'cmbc_cr_detail_2',
			component: cmbc_cr_detail_2,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: ''
			}
		},{
			path: '/cmbc_cr_time_table',
			name: 'cmbc_cr_time_table',
			component: cmbc_cr_time_table,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: ''
			}
		},{
			path: '/cmbc_cr_create_order_1/:service_id/:date/:time/:max_num',
			name: 'cmbc_cr_create_order_1',
			component: cmbc_cr_create_order_1,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: ''
			}
		},{
			path: '/cmbc_cr_create_order_2',
			name: 'cmbc_cr_create_order_2',
			component: cmbc_cr_create_order_2,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: ''
			}
		},{
			path: '/cmbc_cr_order_comfirm',
			name: 'cmbc_cr_order_comfirm',
			component: cmbc_cr_order_comfirm,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: ''
			}
		},{
			path: '/cmbc_cr_order_list',
			name: 'cmbc_cr_order_list',
			component: cmbc_cr_order_list,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: ''
			}
		},{
			path: '/order/detail',
			name: 'cmbc_cr_order_detail',
			component: cmbc_cr_order_detail,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: ''
			}
		},
		
		
		// {
		// 	path: '/venue/book/list_ball',
		// 	name: 'rcb_list',
		// 	component: rcb_list,
		// 	meta: {
		// 		keepAlive: true,
		// 		requireAuth: false,
		// 		title: ''
		// 	}
		// }, {
		// 	path: '/venue/book/detail_ball/:serviceId',
		// 	name: 'rcb_detail',
		// 	component: rcb_detail,
		// 	meta: {
		// 		keepAlive: false,
		// 		requireAuth: false,
		// 		title: ''
		// 	}
		// }, {
		// 	path: '/venue/book/detail_timetable/:serviceId/:sportType/:bookDate/:venueName',
		// 	name: 'rcb_timetable',
		// 	component: rcb_timetable,
		// 	meta: {
		// 		keepAlive: false,
		// 		requireAuth: false,
		// 		title: ''
		// 	}
		// },

	]
})
router.beforeEach((to, from, next) => {
	let openid = localStorage.getItem("openid");
	// console.log(to);
	if (to.meta.requireAuth) {
		if (!openid) {
			next();
		} else {
			next();
		}
	} else {
		next();
	}
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js